const PAYMENT_QUERY_KEYS = [
    "amount",
    "paymentPlatform",
    "paymentSuccess",
    "success",
    "isDeposit",
    "settlementType",
    "settlementCheckout",
    "refundId",
    "refundAmount",
    "refundStatus",
    "reservationProcess",
    "reservationType",
    "resID",
    "carID",
    "extensionPayment",
    "extensionDropoffDate",
    "insuranceName",
    "cardLast4",
];

export const hasPaymentRelatedParams = (searchParams) => {
    if (!searchParams) return false;
    return (
        searchParams.get("paymentSuccess") === "true" ||
        Boolean(searchParams.get("paymentPlatform")) ||
        searchParams.get("extensionPayment") === "true"
    );
};

export const isPaymentFailed = (searchParams, fullPaymentRequired = false) => {
    if (!searchParams) return false;

    const paymentFailed =
        searchParams.get("paymentSuccess") === "false" || searchParams.get("success") === "false";
    if (!paymentFailed) return false;

    const reservationProcess = searchParams.get("reservationProcess")?.trim().toLowerCase() || null;
    if (reservationProcess === "instant") return true;

    const hasPaymentPlatform = Boolean(searchParams.get("paymentPlatform"));
    const isScheduledWithoutPaymentRequired =
        reservationProcess === "scheduled" && !fullPaymentRequired && !hasPaymentPlatform;

    return fullPaymentRequired || (hasPaymentPlatform && !isScheduledWithoutPaymentRequired);
};

export const cleanupPaymentUrlParams = () => {
    try {
        const url = new URL(window.location.href);
        PAYMENT_QUERY_KEYS.forEach((key) => url.searchParams.delete(key));
        window.history.replaceState({}, "", url.toString());
    } catch {
        // ignore malformed URLs in non-browser contexts
    }
};

export const buildCoverageAddedPath = (reservationId, info = {}) => {
    const params = new URLSearchParams();
    if (info.insuranceName) params.set("insuranceName", info.insuranceName);
    if (typeof info.amount === "number") params.set("amount", String(Math.round(info.amount * 100)));
    if (info.cardLast4) params.set("cardLast4", info.cardLast4);
    const qs = params.toString();
    return `/reservations/${reservationId}/coverage-added${qs ? `?${qs}` : ""}`;
};

export const buildCoveragePaymentUrls = ({
    reservationId,
    dueAmount,
    insuranceName,
    provider,
    selectedInsuranceId,
    reservation,
    companyId,
}) => {
    const { origin } = window.location;
    const coverageAddedBase = `${origin}/reservations/${reservationId}/coverage-added`;
    const addCoverageBase = `${origin}/reservations/${reservationId}/add-coverage`;

    const successUrl = `${coverageAddedBase}?success=true&resID=${reservationId}&carID=${reservation?.carSelected?.id || ""}&amount=${(dueAmount * 100).toFixed()}&paymentSuccess=true&isDeposit=true&paymentPlatform=stripe&reservationProcess=scheduled&insuranceName=${encodeURIComponent(insuranceName || provider)}`;

    const cancelUrl = `${addCoverageBase}?success=false&paymentSuccess=false&paymentPlatform=stripe`;

    const paymentMetadata = {
        reservationProcess: "scheduled",
        reservationId,
        email: reservation?.email,
        companyId,
        insuranceId: selectedInsuranceId,
        carId: reservation?.carSelected?._id || reservation?.carLinked?.[0]?._id || "",
        locationId: typeof reservation?.pickupLocation === "string"
            ? reservation.pickupLocation
            : reservation?.pickupLocation?._id || reservation?.pickupLocation?.id || "",
        category:
            typeof reservation?.category === "string"
                ? reservation.category
                : reservation?.category?._id || reservation?.category?.id || "",
    };

    return { successUrl, cancelUrl, paymentMetadata };
};

export const parseCoverageAddedInfo = (searchParams) => ({
    insuranceName: searchParams?.get("insuranceName") || undefined,
    amount: searchParams?.get("amount") ? Number(searchParams.get("amount")) / 100 : undefined,
    cardLast4: searchParams?.get("cardLast4") || undefined,
});
